module.exports = __webpack_public_path__ + "static/media/calendar_white.155c6401.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/calendar_white.svg
// module id = 220
// module chunks = 0